import AxiosAPI from '../../../utils/AxiosAPI';

// -- Get Service List
export const ApiGetServicesList = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services/`, {
                q: params.q,
                status: params.status,
                orderby: params['order-by'],
                sort: params.sort,
                cpp: 12,
                page: params.page
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// --Service Progress
export const ApiMakeImplementItem = (serviceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services-progress/${serviceId}/implement`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Service mark as ongoing
export const ApiMakeOngoingItem = (serviceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services-progress/${serviceId}/ongoing`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// Service mark as done
export const ApiMakeDoneItem = (serviceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services-progress/${serviceId}/completed`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Service make iteration
export const ApiMakeIterationItem = (serviceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services-progress/${serviceId}/iteration`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Get Activity Log
export const ApiGetServiceActivityLog = (serviceId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services/${serviceId}/activity-log`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export default null;
